module.exports = __webpack_public_path__ + "img/contentInfo.886d9c72.png";